import { BundleBase } from "../../../../backend/src/common/bundle/BundleBase";
import BUNDLE from "@/graphql/declaration/Bundle.gql";
import BUNDLE_SHEET from "@/graphql/declaration/BundleSheet.gql";
import BUNDLE_BALANCES from "@/graphql/declaration/BundleBalances.gql";
import PROFILE_COMPANY_BY_COMPANY_ID from "@/graphql/company/ProfileCompanyByCompanyId.gql";
import FORM_TAX_FORM from "@/graphql/taxForm/form.gql";
import FORM_TAX_FORMS from "@/graphql/taxForm/Forms.gql";
// import CREATE_BUNDLE from '@/graphql/declaration/CreateBundle.gql';
import UPSERT_BUNDLE from "@/graphql/declaration/UpsertBundle.gql";
// import UPSERT_BUNDLE_SHEET from '@/graphql/declaration/UpsertBundleSheet.gql';
import BUNDLE_FIXED_ASSETS from "@/graphql/declaration/BundleFixedAssets.gql";
import BUNDLE_EXTRA_DATA from "@/graphql/declaration/BundleExtraData.gql";
import DELETE_BUNDLE_SHEET from "@/graphql/declaration/DeleteSheet.gql";

import BOOKLET_TEMPLATES from "@/graphql/booklet/BookletTemplates.gql";
import UPSERT_BOOKLET_TEMPLATE from "@/graphql/booklet/UpsertBookletTemplate.gql";
// import BOOKLET_TEMPLATE from "@/graphql/booklet/BookletTemplate.gql";
import COMPANY_SCI_DETAILS from "@/graphql/company/CompanySCIDetails.gql";
import BUNDLE_COMPANY_INFOS from "@/graphql/declaration/BundleCompanyInfos.gql";
import ACCOUNTING_PERIOD from "@/graphql/accountingPeriod/AccountingPeriod.gql";
import ACCOUNTING_FIRMS_OF_COMPANY from "@/graphql/company/AccountingFirmsOfCompany.gql";
import COMPANY_DETAILS from "@/graphql/company/CompanyDetails.gql";

// import { apolloClient } from "@/apollo.services";
import { ApolloServices } from "@/vue-apollo";
import { cloneDeep } from "lodash";
import { SheetManager } from "../../../../backend/src/common/taxform/SheetManager";

export class BundleFront extends BundleBase {
    private apollo = null;

    private constructor(
        // Il est en private car il ne faut pas l'initialiser avec des le constructeur
        bundleId: string = "",
        companyId: string = "",
        accountingPeriodId: string = "",
        userId: string = "",
        createBundleN1: boolean = false,
        // generalLedger: any,
    ) {
        super(bundleId, companyId, accountingPeriodId, userId);
        // this.apollo = apolloClient;
        this.apollo = ApolloServices.getCreateApolloProvider().defaultClient;

        if (createBundleN1) {
            this.bundleN1 = new BundleFront(null, companyId, null, userId);
        }
    }

    static async instanciate(
        companyId: string,
        accountingPeriodId: string,
        userId: string,
        bundleId: string = "",
    ): Promise<BundleFront> {
        const bundle = new BundleFront(bundleId, companyId, accountingPeriodId, userId, true);
        await bundle.afterInstanciate();
        return bundle;
    }

    static async instanciateReadOnlyBundleSheet(
        companyId: string,
        userId: string,
        bundeSheetId: string,
    ): Promise<SheetManager> {
        const bundle = new BundleFront(null, companyId, null, userId);
        return await bundle.getReadOnlyBundleSheet(bundeSheetId);
    }

    async getBundleQuery() {
        try {
            if (this.bundleId) {
                const bundle = await this.apollo.query({
                    query: BUNDLE,
                    variables: {
                        bundleId: this.bundleId,
                    },
                    fetchPolicy: "network-only",
                });
                this.bundle = cloneDeep(bundle.data.declaration);
            } else {
                this.bundle = null;
            }
        } catch (error) {
            console.error("Error getting bundle", error);
            this.bundle = null;
        }
    }

    async getBundleSheetQuery(bundleSheetId) {
        try {
            const bundle = await this.apollo.query({
                query: BUNDLE_SHEET,
                variables: {
                    bundleId: bundleSheetId,
                },
            });
            return cloneDeep(bundle.data.declaration);
        } catch (error) {
            console.error("Error getting bundleSheet", error);
            return null;
        }
    }

    async getSettingsVariablesQuery() {
        const { data } = await this.apollo.query({
            query: PROFILE_COMPANY_BY_COMPANY_ID,
            fetchPolicy: "network-only",
            variables: {
                id: this.companyId,
            },
        });
        // console.log("settings variables", data)
        return data?.profileCompany ? cloneDeep(data.profileCompany) : null;
    }

    async getGeneralLedgerQuery() {
        const data = await this.apollo.query({
            query: BUNDLE_BALANCES,
            variables: {
                companyId: this.companyId,
                accountingPeriodId: this.accountingPeriodId,
            },
        });
        return cloneDeep(data.data.bundleBalances);
    }

    async getFixedAssetsQuery() {
        // ** front BUNDLE_FIXED_ASSETS uses bundleFixedAssets resolver
        // ** who calls back generateBundleFixedAssets > returns error: bundleFixedAssets || formatedFixedAssets
        try {
            const fixedAssets = await this.apollo.query({
                query: BUNDLE_FIXED_ASSETS,
                variables: {
                    userId: this.userId,
                    companyId: this.companyId,
                    accountingPeriodId: this.accountingPeriodId,
                },
            });
            return fixedAssets.data?.bundleFixedAssets
                ? cloneDeep(fixedAssets.data.bundleFixedAssets)
                : null;
        } catch (error) {
            console.error("Error getting fixed assets", error);
            return null;
        }
    }

    async getExtraDataQuery() {
        try {
            const result = await this.apollo.query({
                query: BUNDLE_EXTRA_DATA,
                variables: {
                    companyId: this.companyId,
                    accountingPeriodId: this.accountingPeriodId,
                    year: this.importFilesMillesim,
                },
            });
            return result.data.bundleExtraData.output
                ? cloneDeep(result.data.bundleExtraData.output)
                : null;
        } catch (error) {
            console.error("Error getting fixed assets", error);
            return null;
        }
    }

    async getAccountingPeriodQuery() {
        const accountingPeriod = await this.apollo.query({
            query: ACCOUNTING_PERIOD,
            variables: {
                id: this.accountingPeriodId,
            },
        });

        return cloneDeep(accountingPeriod.data.accountingPeriod);
    }

    async deleteBundleSheetQuery(bundleSheetId) {
        await this.apollo.mutate({
            mutation: DELETE_BUNDLE_SHEET,
            variables: {
                id: bundleSheetId,
            },
        });
    }

    async saveBundleQuery() {
        const bsCreations = [];
        const bsUpdates = [];
        for (const cerfaNumber in this.bundleSheets) {
            this.getBundleSheetApolloMutation(cerfaNumber, bsCreations, bsUpdates);
        }
        await this.saveBookletTemplate();
        const data = {
            fixedVariables: this.fixedVariables,
            balances: this.balances,
            buildingBalances: this.buildingBalances,
        };
        const bundle = await this.apollo.mutate({
            mutation: UPSERT_BUNDLE,
            variables: {
                id: this.bundleId || "",
                companyId: this.companyId,
                accountingPeriodId: this.accountingPeriodId,
                bookletTemplateCreate: this.bookletTemplateId
                    ? { connect: { id: this.bookletTemplateId } }
                    : undefined,
                bookletTemplateUpdate: this.bookletTemplateId
                    ? { connect: { id: this.bookletTemplateId } }
                    : undefined,
                createData: !this.bundleId ? data : null,
                updateData: this.bundleId ? data : null,
                createBundleSheets: !this.bundleId ? bsCreations : [],
                updateCreateBundleSheets: this.bundleId ? bsCreations : [],
                updateBundleSheets: bsUpdates,
            },
        });

        return bundle.data.upsertBundle;
    }

    async saveBookletTemplate() {
        if (this.bookletTemplate?.companyScope) {
            // Aucune modification effectué sur le template d'origine -> on ne sauvegarde pas le template
        } else if (
            (!this.isBookletTemplatePersonalized && this.bookletTemplate?.content) || // Création d'un nouveau template
            (this.bookletTemplateId && !this.bookletTemplate?.companyScope) // Modification d'un template personnalisé existant
        ) {
            // Upsert d'un template
            const accountingFirms = await this.getAccountingFirmsOfCompanyQuery();
            if (!accountingFirms?.length) {
                console.error("Aucun cabinet comptable associé à cette entreprise");
                return;
            }
            const { accountingFirm } = accountingFirms[0];

            let name = this.bookletTemplate.name;
            if (this.isBookletTemplatePersonalized) {
                name += " (personnalisé)";
            }

            const id = this.isBookletTemplatePersonalized ? "" : this.bookletTemplateId;

            const newBookletTemplate = await this.apollo.mutate({
                mutation: UPSERT_BOOKLET_TEMPLATE,
                variables: {
                    id,
                    name,
                    createAccountingCompany: { connect: { id: accountingFirm.id } },
                    updateAccountingCompany: { connect: { id: accountingFirm.id } },
                    updateContent: id ? this.bookletTemplate.content : null,
                    createContent: !id ? this.bookletTemplate.content : null,
                },
            });

            this.bookletTemplateId = newBookletTemplate.data.upsertBookletTemplate.id;
        } else {
            debugger;
        }
        return;
    }

    async getBookletTemplatesQuery() {
        const query = await this.apollo.query({
            query: BOOKLET_TEMPLATES,
            fetchPolicy: "network-only",
            variables: {
                companyId: this.companyId,
            },
        });
        // debugger
        return cloneDeep(query.data.bookletTemplatesProd.bookletTemplates);
    }

    async getBuildings() {
        if (this.companyId) {
            const infos = await this.apollo.query({
                query: COMPANY_SCI_DETAILS,
                variables: {
                    companyId: this.companyId,
                },
            });
            if (infos?.data?.company?.buildings?.properties?.length) {
                return cloneDeep(infos.data.company.buildings);
            }
        }
        return null;
    }

    async getCompanyDetailsQuery() {
        if (this.companyId) {
            const companyDetails = await this.apollo.query({
                query: COMPANY_DETAILS,
                variables: {
                    companyId: this.companyId,
                },
            });
            // debugger
            if (companyDetails?.data?.company) {
                return cloneDeep(companyDetails.data.company);
            }
        }
        return null;
    }

    async getCompanyInfosQuery() {
        if (this.companyId) {
            const infos = await this.apollo.query({
                query: BUNDLE_COMPANY_INFOS,
                fetchPolicy: "network-only",
                variables: {
                    companyId: this.companyId,
                },
            });
            const associates = infos?.data?.bundleCompanyInfos?.infos;
            return associates ? cloneDeep(associates) : [];
        }
        return [];
    }

    getBundleSheetApolloMutation(cerfaNumber: string, bsCreations, bsUpdates) {
        const bundleSheet = this.bundleSheets[cerfaNumber];
        if (!bundleSheet) {
            debugger;
            return;
        }
        const values = bundleSheet.getValues();
        if (this.bundleId) {
            if (bundleSheet.id) {
                const update = {
                    where: { id: bundleSheet.id },
                    data: { data: values },
                };
                bsUpdates.push(update);
            } else {
                const create = {
                    company: { connect: { id: this.companyId } },
                    form: { connect: { id: bundleSheet.formId } },
                    data: values,
                };
                bsCreations.push(create);
            }
        } else {
            const create = {
                company: { connect: { id: this.companyId } },
                form: { connect: { id: bundleSheet.formId } },
                data: values,
            };
            bsCreations.push(create);
        }
    }

    async getDeclarationFormQuery({ year, cerfa }) {
        const result = await this.apollo.query({
            query: FORM_TAX_FORM,
            variables: {
                year,
                cerfaNumber: cerfa,
            },
        });
        return cloneDeep(result.data.formTaxForm);
    }

    async getDeclarationFormsQuery({ year, cerfas }) {
        const result = await this.apollo.query({
            query: FORM_TAX_FORMS,
            variables: {
                year,
                cerfaNumbers: cerfas,
            },
        });
        return cloneDeep(result.data.formTaxForms.result);
    }

    async getAccountingFirmsOfCompanyQuery() {
        const response = await this.apollo.query({
            query: ACCOUNTING_FIRMS_OF_COMPANY,
            variables: {
                companyId: this.companyId,
            },
        });
        const accountingFirms = response.data.accountingFirmsOfCompany.accountingFirms;
        return cloneDeep(accountingFirms);
    }

    bookletTemplateIsPersonalized() {
        if (this.bookletTemplate?.companyScope) {
            this.bookletTemplate.companyScope = null;
            // this.bookletTemplateId = null
            this.isBookletTemplatePersonalized = true;
        } else {
            // CompanyScope is undefined, the template is already in personalized mode, so we keep the id to update it
        }
    }

    getV6FixedVariable(): string {
        const firstKey: string = Object.keys(this.bundleSheets || {})[0];
        const firstSheet: SheetManager = firstKey ? this.bundleSheets[firstKey] : undefined;
        const sheetsMillesim: string = firstSheet?.millesim || "";
        return sheetsMillesim;
    }
}
